module.exports = __webpack_public_path__ + "static/img/voice1_right.16059e4a.png";